import React, { useState } from 'react';
import { Card, CardTitle, Row, Col, Container } from 'reactstrap';
import arrowright from '../../images/arrow-right.svg';
import backarrow from '../../images/back-arrow.svg';
import JobsData from '../../data/JobsData.json';

const jobsList = JobsData.jobsList;

const Careercontent = () => {
  const [showDesc, setShowDesc] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [cityId, setCityId] = useState(null);

  const showJobs = () => {
    setShowDesc(false);
    setJobId(null);
    setCityId(null);
  };

  const showDescription = (jobId, cityId) => {
    const jobs = jobsList[String(cityId)] || [];
    jobs.forEach(job => {
      if (job.id === jobId && job.description.length > 0) {
        setCityId(String(cityId));
        setJobId(jobId);
        setShowDesc(true);
      }
    });
  };

  // Find the selected job safely
  let job = null;
  if (cityId) {
    (jobsList[String(cityId)] || []).forEach(jb => {
      if (jb.id === jobId) {
        job = jb;
      }
    });
  }

  return (
    <div className="career-content-section">
      <Container fluid>
        <Row>
          <Col className="mt-60">
            <h2 className="text-center head"> Work with us</h2>
            <p className="head-black text-center m-20 pno">
              Systematrix envisions simplifying business processes with advanced Algorithmic models.
              Our team is motivated to delve deep into Data Science to create cutting edge products.
            </p>
          </Col>
        </Row>
        <Row>
          <Col> <h3 className="text-center head"> Current Openings</h3></Col>
        </Row>
        <Row className="career-navtabs">
          <Col md="12">
            <div>
              {/* Job listing view */}
              <div className={showDesc ? "hide" : ""}>
                <Row>
                  <Col sm="12">
                    <Row>
                      {Object.entries(jobsList).map(([cityId, jobs]) =>
                        jobs.map(job => (
                          <Col sm="6" key={`${cityId}-${job.id}`}>
                            <Card body className="job-card">
                              <div className="card-content">
                                <CardTitle className="job-title">{job.title}</CardTitle>
                                {job.createdAt && (
                                  <span className="timestamp">
                                    Posted on {new Date(job.createdAt).toLocaleDateString("en-US", {
                                      month: "short",
                                      day: "numeric",
                                      year: "numeric"
                                    })}
                                  </span>
                                )}
                                <span
                                  className="readmore-link"
                                  onClick={() => showDescription(job.id, cityId)}
                                >
                                  Read More <img src={arrowright} alt="arrowright" />
                                </span>
                              </div>
                            </Card>
                          </Col>
                        ))
                      )}
                    </Row>
                  </Col>
                </Row>
              </div>

              {/* Job description view */}
              <div id="job_description" className={showDesc ? "" : "hide"}>
                {job && (
                  <>
                    <Row>
                      <Col md={{ size: 10, offset: 1 }}>
                        <span onClick={showJobs} className="back-btn">
                          <img src={backarrow} alt="backarrow" />
                          <span className="back-btn-text">Back to see more jobs</span>
                        </span>
                      </Col>
                    </Row>
                    <Row className="job-details">
                      <Col md={{ size: 10, offset: 1 }}>
                        <h2 className="job-title-head">{job.title}</h2>
                        {job.createdAt && (
                          <p className="job-timestamp">
                            Posted on {new Date(job.createdAt).toLocaleDateString("en-US", {
                              month: "short",
                              day: "numeric",
                              year: "numeric"
                            })}
                          </p>
                        )}
                        <div className="job-des">
                          <h3>Job description</h3>
                          <h5>Responsibilities and Duties:</h5>
                          <ul className="jobdes-list">
                            {(job.description || []).map((desc, i) => <li key={i}>{desc}</li>)}
                          </ul>
                          <h3>Job requirements</h3>
                          <ul className="jobdes-list">
                            {(job.requirements || []).map((req, i) => <li key={i}>{req}</li>)}
                          </ul>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={{ size: 8, offset: 2 }}>
                        <h2 className="text-center btm-text info">
                          If you think you fit in with the above requirements we would love to talk to you
                          about working in our organization.
                        </h2>
                      </Col>
                    </Row>
                    <Row className="getstarted-section">
                      <Col>
                        <h2 className="text-center p20 btm-text">To apply for the job please mention the job title &</h2>
                        <h2 className="text-center btm-text">
                          send us your resume -&nbsp;
                          <a href="mailto:careers@systematrix.ai" className="no-border">
                            <span className="mail-info">careers@systematrix.ai</span>
                          </a>
                        </h2>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Careercontent;